var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mAdm"
  }, [_c('div', {
    staticClass: "mAdm-main"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 0,
      expression: "step === 0"
    }],
    attrs: {
      "src": require('@images/m1.jpg'),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 1,
      expression: "step === 1"
    }],
    attrs: {
      "src": require('@images/m2.jpg'),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 2,
      expression: "step === 2"
    }],
    attrs: {
      "src": require('@images/m3.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "mAdm-btns",
    on: {
      "click": _vm.onGo
    }
  }, [_c('div', {
    staticClass: "btn-go"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "circleLoading"
  }) : [_vm._v("Go")]], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };